export default "__VITE_ASSET__CWIwXFTx__"